import Button from '@/shared/Button'
import FormCreator from '@/shared/FormCreator'

import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'

import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import * as Yup from 'yup'

const mapStateToProps = ({ loading }) => ({
  isLoading: loading['courseTemplate/createCourseTemplateLabel'],
})

const inputConfig = {
  variant: 'standard',
  inputBaseProps: {
    labelSuffix: '',
    flexDirection: 'column',
    alignItems: 'stretch',
    spacing: 0,
    labelProps: { sx: { color: theme => theme.palette.btn_positive.main } },
  },
  color: 'btn_positive',
  endAdornment: args => {
    const {
      value,
      inputProps: { maxLength },
    } = args

    return (
      <Typography
        variant="caption"
        sx={{ color: '#00000040', fontSize: '14px !important' }}
      >{`${value.length}/${maxLength}`}</Typography>
    )
  },
}

const CreateCourseTemplateCategoryDialog = ({
  dispatch,
  isLoading,
  onClose,
  onComplete,
  ...props
}) => {
  const form = useRef()
  const { t } = useTranslation()

  const handleClose = () => {
    onClose?.()
  }

  const handleSubmit = () => {
    const { handleSubmit: formSubmit } = form.current

    formSubmit?.(values => {
      dispatch({
        type: 'courseTemplate/createCourseTemplateLabel',
        payload: values,
        successCallback: () => {
          dispatch({
            type: 'app/notify',
            payload: { message: t('messages.course_category_created'), severity: 'success' },
          })

          onComplete?.()
          handleClose?.()
        },
        errorCallback: message => {
          form.current.setError('email', { type: 'custom', message })
        },
      })
    })?.()
  }

  return (
    <Dialog {...props} maxWidth={'md'}>
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          color: theme => theme.palette.primary.main,
        }}
      >
        {t('general.add_category')}
      </DialogTitle>
      <DialogContent sx={{ width: 500 }}>
        <FormCreator
          ref={form}
          gridItemProps={{ md: 3 }}
          formItems={[
            {
              label: t('general.category_name'),
              name: 'name',
              validator: Yup.string().required(t('validation.category_name_required')),
              defaultValue: '',
              inputConfig: {
                ...inputConfig,
                inputProps: { maxLength: 10 },
                inputBaseProps: {
                  ...inputConfig.inputBaseProps,
                  labelSuffix: (
                    <Typography sx={{ color: theme => theme.palette.primary.main, ml: 1 }}>{`(${t(
                      'general.required',
                    )})`}</Typography>
                  ),
                },
              },
            },
          ]}
          submitComponent={() => null}
          resetComponent={() => null}
        />
      </DialogContent>
      <DialogActions sx={{ alignSelf: 'center' }}>
        <Button
          sx={{ minWidth: 150, marginRight: '30px' }}
          loading={isLoading}
          disabled={isLoading}
          onClick={handleClose}
        >
          {t('general.cancel')}
        </Button>
        <Button
          sx={{ minWidth: 150 }}
          loading={isLoading}
          disabled={isLoading}
          onClick={async () => {
            handleSubmit()
          }}
        >
          {t('general.complete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(mapStateToProps)(CreateCourseTemplateCategoryDialog)
